<template>
  <template v-if="contentStore.select_componentlist != null">
    <v-menu 
      v-model="dialog_com"
      location="start"
      :close-on-content-click="true"
      @update:modelValue="menu_handler"
      >
      <template v-slot:activator="{ props }">
        
        <div class="info-input-group"  style="cursor:pointer">
          <label class="info-input-label">폰트</label>
          <div class="info-select-field" style="line-height:30px" v-bind="props">
            {{value}}
          </div>
        </div>
        <div class="info-input-group" style="cursor:pointer">
          <select class="info-select-field" 
            @change="changefontweight"
            v-model="currentFontWeightIdx"
            >
            <template v-for="cptype in subList_com" :key="cptype.FONTWEIGHT_IDX">
              <option :value="cptype.FONTWEIGHT_IDX">{{cptype.FONTWEIGHT_NAME}}</option>
            </template>
          </select>
        </div>
      </template>

      <v-card class="ma-0 pa-1" style="width:250px;max-width:250px;min-height:400px;max-height:700px">
          <v-list :lines="false" density="compact" nav>
            <v-list-item color="primary"
              v-for="element in itemList_com" class="pa-0 ma-0 pl-2"
              :key="element.FONT_IDX" style="height:20px"
              :value="element" 
              @mouseover="previewfont(element)"
              @click="selectfont(element)"
              >
              <template v-if="element.FONT_WEIGHT != null && element.FONT_WEIGHT.length > 0">
                <label :style="`font-size:14px; font-family:${element.FONT_FAMILY};font-weight:${element.FONT_WEIGHT}`">{{ element.FONT_NAME }}</label>
              </template>
              <template v-else>
                <label :style="'font-size:14px; font-family:'+element.FONT_FAMILY">{{ element.FONT_NAME }}</label>
              </template>
            </v-list-item>
          </v-list>
        <v-row dense justify="center" class="pa-0 ma-0">
          <v-col cols="11">
            <div style="background:gray;height:1px;" />
          </v-col>
        </v-row>
        <v-card-actions>
          <v-row justify="center">
            <v-btn variant="text" size="small" @click="close_com">닫기</v-btn>
          </v-row>
        </v-card-actions>
      </v-card>

    </v-menu>
  </template>
</template>

<script>
import wait from 'waait';
import { useContentStore } from "@/stores/content";

export default {
  
  components:{
    
  },

  props:{
    value: String, // 현재 폰트명
  },

  emits: ['change'],

  watch:{
    value: async function(v1){
      if(v1){
        //console.log("font change value...");
        await wait(250);
        this.backupfont();
        
        // 현재 폰트의 font_idx 찾기
        const foundFont = this.itemList_com.find(item => item.FONT_NAME === v1);
        if(foundFont) {
          this.loadfontweight(foundFont.FONT_IDX);
        }
      }
    },
  },
  
  setup(){
    const contentStore = useContentStore();
    return {contentStore};
  },

  mounted(){
    this.backupfont();
    this.search_run_com();
  },

  data: ()=> ({
    dialog_com : false,
    load_flag : false,

    //백업
    font_name:"",
    textfont:"",
    font_url:"",
    font_format:"",
    font_weight:"",
    font_style:"",
    font_idx:-1,
    fontweight_idx:-1,

    itemList_com: [],
    subList_com: [],
    search_keyword_com : '',
    currentFontWeightIdx: -1,
  }),

  methods: {

    backupfont(){
      //console.log("backup font...");
      this.font_name = this.value || "";
    },

    changefontweight(event){
      const foundItem = this.subList_com.find(item => Number(item.FONTWEIGHT_IDX) === Number(event.target.value));
      if(foundItem){
        this.setfontweight(foundItem);
      }
    },

    //마우스 오버시 폰트 미리보기 - 다중 선택시에는 미리보기 비활성화
    previewfont(element){
      //console.log("Preview:", element.FONT_NAME);
      // 미리보기는 단일 선택에서만 동작하도록 제한하거나 생략
    },
    
    selectfont(element){
      //console.log("select : " + element.FONT_NAME);
      
      // 선택된 폰트 정보를 부모로 전달
      const fontData = {
        font_name: element.FONT_NAME,
        textfont: element.FONT_FAMILY,
        font_url: element.FONT_PATH_REF,
        font_format: element.FONT_FORMAT,
        font_weight: element.FONT_WEIGHT,
        font_style: "normal",
        font_idx: element.FONT_IDX,
        fontweight_idx: element.FONTWEIGHT_IDX
      };

      this.$emit('change', fontData);
      this.loadfontweight(element.FONT_IDX);
      this.dialog_com = false;
    },

    //검색
    search_run_com(searchkeyword){
      if(searchkeyword != null && searchkeyword != undefined && searchkeyword.length > 0){
        this.search_keyword_com = searchkeyword;
      }else{
        this.search_keyword_com = '';
      }
      this.loadpage_com();
    },

    async loadpage_com(){
      let token;
      try{
        token = await this.$fireauth.currentUser.getIdToken();
      }catch(error){
        token = this.$userStore.fireToken;
      }
      
      this.$http.post(this.$api_home+'/ComFontList',{
            search_keyword: this.search_keyword_com == null || this.search_keyword_com == undefined ?  '' : this.search_keyword_com
          , sort_name: "FONT_NAME"
          , sort_type: "ASC" 
          , page: 1
          , pagerow: 9999
      },{headers: { firetoken:token}})
      .then((result)=>{
          
          if(result.data.resultCode == 0){
            
              const list = result.data.resultData;
              this.itemList_com.splice(0, this.itemList_com.length);

              list.forEach(element => {
                  this.itemList_com.push(element); 

                  //폰트 등록
                  let fonturl = "url('"+element.FONT_PATH_REF+"')";
                  if(isNaN(element.FONT_FORMAT)){
                    fonturl += " format('"+element.FONT_FORMAT+"')"
                  }

                  let fontoption = {weight: element.FONT_WEIGHT ? element.FONT_WEIGHT : "normal", style:"normal"};
                  var temp_font = new FontFace(element.FONT_FAMILY, fonturl, fontoption);
                  document.fonts.add(temp_font);
              });

          }else if(result.data.resultCode == 2){
              this.$swal("토큰 만료로 인해 다시 로그인해주세요.");
              this.$emitter.emit('clearsession');
          }
      })
      .catch((error)=>{
          
      });
    },        

    async loadfontweight(fidx){
      let token;
      try{
        token = await this.$fireauth.currentUser.getIdToken();
      }catch(error){
        token = this.$userStore.fireToken;
      }
        
      this.$http.post(this.$api_home+'/ComFontWeightList',{
        FONT_IDX: fidx
      },{headers: { firetoken:token}})
      .then((result)=>{
          
          if(result.data.resultCode == 0){
              
              const list = result.data.resultData;
              this.subList_com.splice(0, this.subList_com.length);

              list.forEach(element => {
                  this.subList_com.push(element); 
                  //폰트 등록
                  let fonturl = "url('"+element.FONT_PATH_REF+"')";
                  if(isNaN(element.FONT_FORMAT)){
                    fonturl += " format('"+element.FONT_FORMAT+"')"
                  }

                  let fontoption = {weight:element.FONT_WEIGHT == null || element.FONT_WEIGHT.length == 0 ? "normal" : element.FONT_WEIGHT, style:"normal"};
                  var temp_font = new FontFace(element.FONT_FAMILY, fonturl, fontoption);
                  document.fonts.add(temp_font);
              });

              if(this.subList_com.length > 0) {
                this.setfontweight(this.subList_com[0]);
              }

          }else if(result.data.resultCode == 2){
              this.$swal("토큰 만료로 인해 다시 로그인해주세요.");
              this.$emitter.emit('clearsession');
          }
      })
      .catch((error)=>{
          
      });
    },                

    setfontweight(element){
      const fontData = {
        font_name: element.FONT_NAME,
        textfont: element.FONT_FAMILY,
        font_url: element.FONT_PATH_REF,
        font_format: element.FONT_FORMAT,
        font_weight: element.FONT_WEIGHT,
        font_style: "normal",
        font_idx: element.FONT_IDX,
        fontweight_idx: element.FONTWEIGHT_IDX
      };

      this.currentFontWeightIdx = element.FONTWEIGHT_IDX;
      this.$emit('change', fontData);
    },

    //다이얼로그 닫기
    close_com () {
      this.dialog_com = false
    },

    menu_handler(){
      this.backupfont();
    },
  }
}
</script>

<style scoped>
.fontselect{
  width:100%;
  border: 1px gray solid; 
  border-radius:5px; 
  padding-left:5px;
  font-size:14px;
  line-height: 28px;
  height:28px;
  font-weight: bold;
}
.dropdown-icon {
  margin-left: 10px;
  color: #333333;
  font-size: 28px;
}
</style>